import { render } from "./TraitRanksFiltersItems.vue?vue&type=template&id=38327e28"
import script from "./TraitRanksFiltersItems.vue?vue&type=script&lang=js"
export * from "./TraitRanksFiltersItems.vue?vue&type=script&lang=js"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__